<section [class.open]="vm.open">
  <h2 class="heading-5">Do you need extra support?</h2>
  <button class="arrow-button" (click)="open.set(!open())">
    <div class="extra-support">
      <p class="body mt-8">Let us know if you need more support during your repair.</p>
    </div>

    <i
      class="fa-solid fa-chevron-right fa-lg"
      style="color: #0065c4"
      [class.fa-chevron-up]="vm.open"
      [class.fa-chevron-right]="!vm.open"
    ></i>
  </button>
</section>

<section class="content" [appAnimateOpen]="vm.open">
  <section>
    <p class="body bold">Your home visits</p>
    <p class="body mt-2">Select any of these that you need when we visit you:</p>
    <div class="checkbox-wrapper">
      <label for="allow-time">
        <input type="checkbox" id="allow-time" />
        <p class="body">Please allow more time for me to answer the door</p>
      </label>
      <label for="ring-doorbell">
        <input type="checkbox" id="ring-doorbell" />
        <p class="body">Please ring the doorbell when you arrive</p>
      </label>
    </div>

    <div class="divider mt-16 mb-16"></div>

    <p class="body bold mt-16">Your medical needs</p>
    <p class="body mt-2">Select any of these reasons that apply:</p>
    <div class="checkbox-wrapper">
      <label for="need-fridge">
        <input type="checkbox" id="need-fridge" />
        <p class="body">I need a fridge for medicine or allergen-free food</p></label
      >
      <label for="special-diet">
        <input type="checkbox" id="special-diet" />
        <p class="body">I need my cooking appliance for a special diet</p>
      </label>
      <label for="need-heating">
        <input type="checkbox" id="need-heating" />
        <p class="body">I need heating because of a health condition</p>
      </label>
    </div>

    <div class="divider mt-16 mb-16"></div>

    <p class="body bold">Do you have any other health or personal needs we should know about before visiting?</p>
    <p class="body">Note: we can't change the time of your booking.</p>

    <app-text-area
      dataLabel="Please tell us anything else we should know here."
      dataTestId="should-know-textarea"
      placeHolder="Please tell us anything else we should know here."
      class="mt-8"
    >
    </app-text-area>

    <div class="divider mt-16 mb-16"></div>

    <p class="body">
      This information is optional. By sharing it with us, you agree that we can use it to support you.
    </p>
    <div class="button-container">
      @if (!buttonsHidden) {
        <app-button dataLabel="goBack" (click)="open.set(false)"> Back </app-button>
        <app-button dataLabel="saveAndSubmit" (click)="saveAndSubmit()"> Save and submit </app-button>
      }
    </div>

    @if (showWarningMessage) {
      <div class="divider mt-16 mb-16"></div>
      <p class="body bold">You can’t edit this form after you submit it. Do you want to continue?</p>
      <div class="button-container">
        <app-button dataLabel="yes" (click)="handleSubmit()"> Yes </app-button>
        <app-button dataLabel="no"> No </app-button>
      </div>
    }

    @if (needsSubmitted) {
      <p class="body">Thanks for letting us know your support needs.</p>
    }
  </section>
</section>
